/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const DUPLICATE_ITEM = 'DUPLICATE_ITEM';
export const LOAD_DUPLICATE_ITEM = 'LOAD_DUPLICATE_ITEM';
